import { Component, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// export type ValueFinisherFn = (value: string) => string;

function capitalize(text: string): string {
  if (!text) {
    return text;
  }

  return text.replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
}

@Component({
  selector: 'hfc-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextInputComponent,
      multi: true
    }
  ]
})
export class TextInputComponent implements ControlValueAccessor {
  public value = '';

  @Input()
  public type = 'text';

  @Input()
  public min: number;

  @Input()
  public max: number;

  @Input()
  public maxlength = 255;

  @Input()
  public placeholder = '';

  @Input()
  public prefix: string;

  @Input()
  public sufix = '';

  @Input()
  public icon = '';

  @Input()
  public capitalize = false;

  @Input()
  public mask: string;

  @Input()
  public autocomplete: string;

  @Input()
  public inputId: string;

  @Input()
  public disableDecimal?: boolean = false;

  @Input()
  public numbersOnly?: boolean = false;

  @Input()
  @HostBinding('class.readonly')
  public readonly: boolean;

  public _currency = false;
  @Input()
  public set currency(value: boolean) {
    this._currency = value;

    if (value) {
      this.mask = 'separator';
    }
  }

  public _integer = false;
  @Input()
  public set integer(value: boolean) {
    this._integer = value;

    if (value) {
      this.mask = '0*';
    }
  }

  @Input()
  public pattern: string;

  @HostBinding('class.focus')
  public focus = false;

  // @Input()
  // public valueFinisher: ValueFinisherFn;

  public onModelChange() {
    if (this.numbersOnly && this.value != null) {
      this.value = String(this.value).replace(/\D/g, '');
    }
    let value = this.value;
    // Strip thousand-separator commas so the form control receives a clean numeric string
    if ((this._currency || (this.mask && this.mask.startsWith('separator'))) && value != null) {
      value = String(value).replace(/,/g, '');
    }
    this.onChane && this.onChane(this.capitalize ? capitalize(value) : value);
  }

  public onInputBlur() {
    this.onTouchedFn && this.onTouchedFn();
  }

  @HostListener('click')
  public setFocus() {
    this.el.nativeElement.querySelector('input').focus();
  }

  constructor(private el: ElementRef) {}

  private onChane: (value: string) => void;
  private onTouchedFn: () => void;

  public blockInvalidInput(event: KeyboardEvent): void {
    if (!this.numbersOnly && !this._currency && !(this.mask && this.mask.startsWith('separator'))) {
      return;
    }

    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (this.numbersOnly && !/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if ((this._currency || (this.mask && this.mask.startsWith('separator'))) && event.key === ',') {
      event.preventDefault();
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onChane = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }
}
